import { useState, useEffect } from 'react';
import Wildcatz from './Wildcatz';
import ComingSoon from './ComingSoon';

export default function App() {
  const [page, setPage] = useState(window.location.hash === '#/coming-soon' ? 'coming-soon' : 'home');

  useEffect(() => {
    const handleHash = () => {
      const hash = window.location.hash;
      if (hash === '#/coming-soon') {
        setPage('coming-soon');
        window.scrollTo(0, 0);
      } else if (hash === '#/' || hash === '' || hash === '#') {
        setPage('home');
        window.scrollTo(0, 0);
      }
      // Don't change page for anchor links like #sports, #leaderboard, etc.
    };
    window.addEventListener('hashchange', handleHash);
    return () => window.removeEventListener('hashchange', handleHash);
  }, []);

  return page === 'coming-soon' ? <ComingSoon /> : <Wildcatz />;
}
